import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var ContactEmailTransactionApi = /** @class */ (function () {
    function ContactEmailTransactionApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    ContactEmailTransactionApi.initialize = function (basePath, fetchApi) {
        if (!ContactEmailTransactionApi.instance) {
            ContactEmailTransactionApi.instance = new ContactEmailTransactionApi(basePath, fetchApi);
        }
        return ContactEmailTransactionApi.instance;
    };
    ContactEmailTransactionApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1ContactEmailTransactionApi(new Configuration(config));
    };
    return ContactEmailTransactionApi;
}());
export { ContactEmailTransactionApi };
